// @flow
import { SET_PERMISSIONS } from 'action_types/AuthorizationActionTypes';
import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';

export function fetchPermissions(userId: string) {
  return ApiClient.get({
    path: `/users/${userId}/resources`
  }).then(response => {
    Dispatcher.dispatch({
      type: SET_PERMISSIONS,
      payload: response.resources
    });
  });
}
